import { useTranslation } from "react-i18next";

import { formatTimelineTick, formatTimelineTooltipLabel } from "./charts.utils";

import type { TimelineGranularity } from "./charts.types";

interface TimelineFormatters {
  formatTick: (date: string) => string;
  formatTooltipLabel: (date: unknown) => string;
  formatAverageTooltipLabel: (date: unknown) => string;
}

function useTimelineFormatters(
  granularity: TimelineGranularity,
): TimelineFormatters {
  const { t, i18n } = useTranslation("editor-analytics");
  const lang = i18n.language;

  const formatWeek = (formattedDate: string): string =>
    t("charts.weekOf", { date: formattedDate });
  const formatTick = (date: string): string =>
    formatTimelineTick(date, granularity, lang);
  const formatTooltipLabel = (date: unknown): string =>
    formatTimelineTooltipLabel(String(date), granularity, lang, formatWeek);
  const formatAverageTooltipLabel = (date: unknown): string => {
    const label = formatTooltipLabel(date);
    return granularity === "day"
      ? label
      : t("charts.dailyAverageOf", { label });
  };

  return { formatTick, formatTooltipLabel, formatAverageTooltipLabel };
}

export default useTimelineFormatters;
